export default __webpack_public_path__ + "opcoatlas.de554ba.png";